import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedDataService } from '../services/shared-data.service';
import { CombinedStore } from 'src/app/core/combined.store';

@Injectable({
  providedIn: 'root'
})
export class StepActivationGuard implements CanActivate {
  store = inject(CombinedStore);
  constructor(private sharedDataService: SharedDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url.split('/')[2];
    const subscription = this.sharedDataService.getSubscription();
    let groupStep = 0;

    let indexReprise = 0;
    //Remettre 0 mais 7 si reprise devis, 11 (supporting-document) si reprise signature
    if (this.store.context().referenceContrat) {
      indexReprise = (this.store.declaration()?.vehicles?.vehicles?.length ?? 0) > 0 ? 11 : 12;
      //Check Si plusieurs groupstep dans la subscription => groupStep = 1; (exemple SA)
    } else if (this.store.context().referenceDevis) indexReprise = 7;

    if (subscription) {
      const index = subscription()?.findStepIndexesByUrl(currentUrl);
      this.sharedDataService.setGroupStep(index?.groupIndex ?? groupStep);
      this.sharedDataService.setStepIndex(index?.stepIndex ?? indexReprise);
    }

    return true;
  }
}
